import {useEffect} from "react";

import {getAllFilterGroups} from "./FeaturesFiltersActions";

const useGetAllFiltersGroups = (allFilterGroups) => {
  useEffect(() => {
    if (!allFilterGroups.length) {
      getAllFilterGroups();
    }
  }, []);
  return null
}

export default useGetAllFiltersGroups
